<template>
    <div class="o-announcements">
        <div class="container">
            <div class="o-announcements__header pt-3">
                <div class="row align-items-center">
                    <div class="col-12 order-1">
                        <bread-crumbs
                            force-default-url
                            :default-url="'my-business'"
                        />
                    </div>
                </div>
            </div>

            <div class="o-announcement__list">
                <div class="row">
                    <div class="col-lg-3 d-flex flex-column mb-0 mb-md-3">
                        <the-filters
                            @applyFilters="applyFilters"
                            :filters="filters"
                            :module-name="'announcements'"
                            :subtitle="'Pokaż ogłoszenia'"
                        />
                    </div>
                    <div class="col-lg-9">
                        <div class="c-settings pt-1 mb-0">
                            <sub-section-header title="Tablica ogłoszeń"/>
                            <div
                                class="c-settings-filters ml-auto"
                                v-if="areAnnouncements"
                            >
                                <sort-component
                                    :text="'Sortuj po:'"
                                    :module-name="'announcements'"
                                    :options="
                                        $store.getters.getAnnouncementsSortOptions
                                    "
                                    @onChange="setSortOptions"
                                ></sort-component>
                            </div>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between gap-1"
                        >
                            <header-tabs
                                class="mt-3 mb-3 mb-md-4"
                                style="flex: 1"
                                :content="headerTabs"
                                :active-tab="activeTab"
                            />
                            <the-btn
                                text="Oznacz wszystkie jako przeczytane"
                                class="btn-outline-custom d-none d-lg-flex"
                                @click.native="markAllAnnouncementAsRead"
                            />
                        </div>

                        <selected-filters
                            class="mb-3 mb-md-4 mt-0"
                            :filters="filters"
                            :module-name="'announcements'"
                            @applyFilters="applyFilters"
                        />

                        <page-preloader
                            v-if="status === 'loading'"
                            min-height="50vh"
                            :is-loading="true"
                        />

                        <template v-else-if="areAnnouncements">
                            <announcements-list
                                class="mb-4"
                                style="min-height: 50vh;"
                                :list="announcements"
                                @markAllAnnouncementAsRead="markAllAnnouncementAsRead"
                            />

                            <div
                                class="
                                    d-flex justify-content-sm-between
                                    justify-content-cente flex-column flex-sm-row mb-5
                                "
                            >
                                <the-pagination
                                    :pagination="paginationMap"
                                    @change="setPagination"
                                />
                                <results-per-page
                                    :per-page="initialLimit"
                                    :text="'Pokazuj na stronie:'"
                                    :on-change="changeResultsPerPage"
                                    :options="[10, 20, 50]"
                                    class="align-self-center pl-sm-0 pl-4"
                                ></results-per-page>
                            </div>
                        </template>
                        <div
                            v-else
                            v-text="'Brak wyników'"
                            class="mt-3 mb-5"
                            style="min-height: 35vh;"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AnnouncementsList from '@/components/announcements/AnnouncementsList.vue'

export default {
    data() {
        return {
            initialLimit: 10,
            activeTab: 0
        }
    },
    components: {
        AnnouncementsList
    },
    methods: {
        fetch(params) {
            return this.$store.dispatch('loadAnnouncements', {
                ...params,
                archival: this.activeTab === 1
            })
        },
        async fetchInit() {
            await this.fetch({ limit: this.initialLimit, offset: 0 })
        },
        async setPagination(page) {
            history.pushState({}, null, `?page=${page}${window.location.hash}`)
            await this.fetch({
                limit: this.initialLimit,
                offset: (page - 1) * this.initialLimit
            })
            const top = document.querySelector('.o-announcements')
            this.$scrollTo(top, 300, {
                offset: -140
            })
        },
        changeResultsPerPage(perPage) {
            this.initialLimit = perPage
            this.fetch({ limit: perPage, offset: 0 })
            const top = document.querySelector('.o-announcements')
            this.$scrollTo(top, 300, {
                offset: -140
            })
        },
        setSortOptions() {
            history.pushState({}, null, `?page=1${window.location.hash}`)
            this.fetchInit()
        },
        applyFilters() {
            this.fetch()
        },
        markAllAnnouncementAsRead() {
            this.$store.dispatch('markAllAnnouncementAsRead')
        }
    },
    computed: {
        fetchPaging() {
            return {
                offset: this.pagination.offset,
                limit: this.pagination.limit
            }
        },
        announcements() {
            return this.$store.getters.getAnnouncements
        },
        pagination() {
            return this.$store.getters.getAnnouncementsPagination
        },
        paginationMap() {
            const p = this.pagination
            return {
                nextPage:
                    p.offset + p.count >= p.total
                        ? ''
                        : (p.count + p.offset) / p.limit + 1,
                page: Math.ceil((p.count + p.offset) / p.limit),
                perPage: p.limit,
                prevPage: p.offset === 0 ? '' : p.offset / p.limit,
                totalPages: Math.ceil(p.total / p.limit),
                totalRecords: p.total
            }
        },
        areAnnouncements() {
            return this.announcements && this.announcements.length
        },
        status() {
            return this.$store.getters.getAnnouncementsStatus
        },
        searchResultCounter() {
            return this.$store.getters.getAnnouncementsSearchResultCount
        },
        headerTabs() {
            return [
                {
                    text: 'Aktualne',
                    hash: '#current',
                    counter: this.searchResultCounter.current
                },
                {
                    text: 'Archiwalne',
                    hash: '#archival',
                    counter: this.searchResultCounter.archival
                }
            ]
        },
        filters() {
            return this.$store.getters.getAnnouncementsFilters
        }
    },
    created() {
        if (this.$route.hash && this.$route.hash.includes('#archival')) {
            this.activeTab = 1
        }

        if (this.filters.id.value) {
            this.fetch()
        } else if (this.$route.query.id) {
            this.$store.commit('SET_ANNOUNCEMENTS_FILTER', {
                filter: 'id',
                value: this.$route.query.id
            })

            this.fetch()
        } else if (this.$route.query.page) {
            this.fetch({
                limit: this.initialLimit,
                offset: (this.$route.query.page - 1) * this.initialLimit
            })
        } else {
            this.fetchInit()
        }
    }
}
</script>
